import React from "react";
import { Flex } from "rebass/styled-components";
import { useRecoilState } from "recoil";

import { PlayButton } from "../../../../../../Components/PlayButton";
import { ReactComponent as Finale } from "../../../../../../Assets/finale.svg";
import { TClipProps } from "../../../../@types";
import {
  formatNumber,
  dateFormatWithDistanceSuffix,
} from "../../../../../../Utilities/Clip";

import { countKills } from "../..";
import { AllstarModalState } from "../../../../../../State/modals";
import { Button } from "../../../../../../Components/Button";
import { ModalType } from "../../../../../../@types";
import { MontageSession } from "../../../../../../State";
import {
  ClipImage,
  ClipIndicator,
  ClipMeta,
  ClipStats,
  ClipTitle,
  FinaleWrapper,
  ImageWrapper,
  KillCount,
  OverlayInfo,
  StyledClip,
} from "./styledComponents";

import theme from "theme/themeThree";
import styled from "styled-components";

export const Clip = ({
  clip,
  index,
  isSelected,
  isFinale,
  willExceedClipLimit,
  handleSelect,
  forceColumnDisplay,
}: TClipProps) => {
  const [montageSession, setMontageSession] = useRecoilState(MontageSession);
  const shouldShowOverlay = willExceedClipLimit && !isSelected;
  const [, setAllstarModalState] = useRecoilState(AllstarModalState);

  const handleRemoveClip = () => {
    const numKills = countKills([clip]);

    setMontageSession({
      ...montageSession,
      clips: montageSession.clips.filter((x: any) => x._id !== clip._id),
      kills: montageSession.kills - numKills,
    });
  };

  const handleOpenClip = (e: React.MouseEvent) => {
    e.stopPropagation();
    setAllstarModalState({
      isOpen: ModalType.SimpleClipViewer,
      data: clip,
      functions: {},
    });
  };

  return (
    <StyledClip
      onClick={() => {
        if (shouldShowOverlay) return;
        handleSelect(clip);
      }}
      columnDisplay={forceColumnDisplay}
    >
      <ImageWrapper
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          handleOpenClip(e);
        }}
      >
        <StyledPlayButton />
        <FinaleWrapper>
          {isFinale ? <Finale /> : <ClipIndicator>{index + 1}</ClipIndicator>}
        </FinaleWrapper>
        <OverlayInfo onlyOnHover={true} />
        <ClipImage
          draggable="false"
          src={`${process.env.REACT_APP_S3_CLIP_BUCKET}/${clip.clipImageThumb}`}
          active={isSelected}
        />
      </ImageWrapper>
      <ClipMeta mb={0} mt={0}>
        <Flex flexDirection={"column"} flex={1} justifyContent={"center"}>
          <ClipTitle>{clip.userClipTitle ?? clip.clipTitle}</ClipTitle>
          <ClipStats>
            {formatNumber(clip.views)} Views •{" "}
            {dateFormatWithDistanceSuffix(clip?.createdDate)}
          </ClipStats>
          <KillCount>
            {countKills([clip])} Kill{countKills([clip]) !== 1 ? "s" : ""}
          </KillCount>
        </Flex>

        <Button
          onClick={handleRemoveClip}
          style={{
            width: 100,
            backgroundColor: theme.colors.alert,
          }}
          classification={"roundedFilled"}
          size={"small"}
          ml={5}
          alignSelf={"center"}
        >
          Remove
        </Button>
      </ClipMeta>
    </StyledClip>
  );
};

const StyledPlayButton = styled(PlayButton)`
  height: 42px;
  left: 50%;
  z-index: 101;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 42px;
  fill: inherit !important;
`;
